import { render } from "./NoAccessView.vue?vue&type=template&id=7e7f8a55"
import script from "./NoAccessView.vue?vue&type=script&lang=js"
export * from "./NoAccessView.vue?vue&type=script&lang=js"

import "./NoAccessView.vue?vue&type=style&index=0&id=7e7f8a55&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__